/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import Notification from "./Notification";
import API from "../../api";
import urls from "../../api/urls";
import { motion } from "framer-motion";
import { spaceBeforeCapital } from "../../utils";
import { notificationConfigureApi } from "../../api/NotificationApi";

function Notifications({
  showNotification,
  newNotification = null,
  setShowNotification,
}) {
  const { NOTIFICATION_SERVICE } = urls;
  const [notificationList, setNotificationList] = useState([]);
  const [unreadNotification, setUnreadNotification] = useState([]);
  const [readNotification, setReadNotification] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [eventType, setEventType] = useState([]);
  const [currentPageNumber, setcurrentPageNumber] = useState({
    all: 1,
    read: 1,
    unread: 1,
  });
  const [totalPages, setTotalPages] = useState({
    all: 0,
    read: 0,
    unread: 0,
  });
  const [totalElements, setTotalElements] = useState({
    all: 0,
    read: 0,
    unread: 0,
  });
  const notificationSize = 10;

  useEffect(() => {
    getNotificationEventType();
  }, []);
  // Fetch initial notifications when component mounts
  useEffect(() => {
    if (showNotification) {
      fetchNotification();
    }
  }, [showNotification]);
  const fetchNotification = async (initial = false, filters = "") => {
    const storedUser = sessionStorage.getItem("userinfo");
    const userId = JSON.parse(storedUser).userId;
    if (userId) {
      setLoading(true);
      const response = await API.Api(
        NOTIFICATION_SERVICE + "notifications"
      ).getwithParams({
        pageNo: initial ? 1 : currentPageNumber.all,
        pageSize: notificationSize,
        topicContents: userId,
        eventType: filters,
      });
      if (response?.status && initial) {
        setLoading(false);
      } else {
        setLoading(false);
      }
      const data = response.response.data;
      setNotificationList(data.content);

      const unreadNotif = await API.Api(
        NOTIFICATION_SERVICE + "notifications"
      ).getwithParams({
        pageNo: initial ? 1 : currentPageNumber.read,
        pageSize: notificationSize,
        topicContents: userId,
        isRead: false,
        eventType: filters,
      });
      const unreadData = unreadNotif.response.data;
      setUnreadNotification(
        unreadData.content?.map((item) => {
          return { ...item, read: false };
        })
      );

      const readNotif = await API.Api(
        NOTIFICATION_SERVICE + "notifications"
      ).getwithParams({
        pageNo: initial ? 1 : currentPageNumber.unread,
        pageSize: notificationSize,
        topicContents: userId,
        isRead: true,
        eventType: filters,
      });
      const readData = readNotif.response.data;
      setReadNotification(
        readData.content?.map((item) => {
          return { ...item, read: true };
        })
      );

      setTotalPages({
        all: data?.page?.totalPages,
        read: readData?.page?.totalPages,
        unread: unreadData?.page?.totalPages,
      });

      setTotalElements({
        all: data?.page?.totalElements,
        read: readData?.page?.totalElements,
        unread: unreadData?.page?.totalElements,
      });
    }
  };

  const getNotificationEventType = async () => {
    const response = await notificationConfigureApi.getNotificationEventType();
    if (response?.status) {
      setEventType(
        response?.response?.data?.data?.map((e) => ({
          value: e?.eventType,
          label: spaceBeforeCapital(e?.eventType),
        })) || []
      );
    }
  };

  // useEffect(() => {
  //   if (newNotification) {
  //     setNotificationList((prev) => [newNotification, ...prev]);
  //     setUnreadNotification((prev) => [newNotification, ...prev]);
  //   }
  // }, [newNotification]);

  const fetchNotif = async (param) => {
    const response = await API.Api(
      NOTIFICATION_SERVICE + "notifications"
    ).getwithParams({ ...param });

    return response;
  };

  const fetchMoreNotifications = async (tab) => {
    const storedUser = sessionStorage.getItem("userinfo");
    const userId = JSON.parse(storedUser).userId;

    let data = null;
    if (userId) {
      if (tab == 0 && currentPageNumber.all < totalPages.all) {
        const response = await fetchNotif({
          pageNo: currentPageNumber.all + 1,
          pageSize: notificationSize,
          topicContents: userId,
        });
        data = response.response.data.content;
        setNotificationList((prev) => {
          return [...prev, ...data];
        });
        setcurrentPageNumber((prev) => ({ ...prev, all: prev.all + 1 }));
      } else if (tab == 1 && currentPageNumber.read < totalPages.read) {
        const response = await fetchNotif({
          pageNo: currentPageNumber.read + 1,
          pageSize: notificationSize,
          topicContents: userId,
          isRead: true,
        });
        data = response.response.data.content;
        setReadNotification((prev) => {
          return [...prev, ...data];
        });
        setcurrentPageNumber((prev) => ({ ...prev, read: prev.read + 1 }));
      } else if (tab == 2 && currentPageNumber.unread < totalPages.unread) {
        const response = await fetchNotif({
          pageNo: currentPageNumber.unread + 1,
          pageSize: notificationSize,
          topicContents: userId,
          isRead: false,
        });
        data = response.response.data.content;
        setUnreadNotification((prev) => {
          return [...prev, ...data];
        });
        setcurrentPageNumber((prev) => ({ ...prev, unread: prev.unread + 1 }));
      }
    }
  };

  const handleReadNotification = async (notificationId) => {
    const storedUser = sessionStorage.getItem("userinfo");
    const userId = JSON.parse(storedUser).userId;
    const markAllAsRead = notificationId ? "notification" : "notifications";
    try {
      await API.Api(NOTIFICATION_SERVICE + markAllAsRead).putCustomHeader(
        {},
        {},
        {
          notificationId,
          userId,
        }
      );

      if (notificationId) {
        const item = unreadNotification.find((i) => i.id === notificationId);

        if (item) {
          setUnreadNotification((prev) =>
            prev.filter((i) => i.id !== notificationId)
          );
          setReadNotification((prev) => [{ ...item, read: true }, ...prev]);
          setNotificationList(() => {
            return notificationList.map((item) => {
              if (item.id === notificationId) {
                item.read = true;
              }
              return item;
            });
          });
        }
      } else {
        const read_notification = notificationList.map((i) => {
          return { ...i, read: true };
        });
        setReadNotification(() => {
          return read_notification;
        });
        setUnreadNotification([]);
        setNotificationList(() => {
          return read_notification;
        });
      }
    } catch (err) {
      console.log("Err: ", err);
    }
  };

  return (
    <>
      <motion.div
        initial={{ x: "200%" }}
        animate={{
          x: showNotification ? "0%" : "200%",
        }}
        exit={{ opacity: 1, x: "100%" }}
        transition={{ type: "tween", duration: 0.3 }}
        style={{
          position: "fixed",
          top: 0,
          right: 20,
          width: "300px",
          height: "auto",
          background: "white",
          boxShadow: "0px 4px 10px rgba(0,0,0,0.2)",
          zIndex: 1000,
        }}
      >
        <Notification
          totalPages={totalPages}
          totalElements={totalElements}
          currentPageNumber={currentPageNumber}
          notificationSize={notificationSize}
          notificationList={notificationList}
          setShowNotification={setShowNotification}
          fetchMoreNotifications={fetchMoreNotifications}
          unreadNotification={unreadNotification}
          readNotification={readNotification}
          handleReadNotification={handleReadNotification}
          fetchInitialData={(filters) => {
            console.log(filters, "filtersss");
            fetchNotification(true, filters);
          }}
          loading={isLoading}
          eventType={eventType}
        />
      </motion.div>
    </>
  );
}

export default Notifications;
